import React from 'react';
export const Hero = () => {
  return <section className="relative pt-24 md:pt-20 pb-8 md:pb-6 flex items-center justify-center overflow-hidden bg-white" data-id="element-148">
      <div className="container mx-auto px-4 md:px-6 lg:px-12 relative z-10" data-id="element-149">
        <div className="max-w-4xl mx-auto text-center space-y-3 md:space-y-4" data-id="element-150">
          <h1 className="text-4xl md:text-7xl font-light tracking-tight" data-id="element-151">
            WELLHAUS™
          </h1>
          <p className="text-lg md:text-2xl font-light text-gray-700" data-id="element-152">
            Premium Water. Elevated Experience.
          </p>
          <p className="text-sm md:text-base text-gray-600 max-w-2xl mx-auto px-4" data-id="element-153">
            Still, sparkling, alkaline, hot & cold — from one beautiful
            countertop system.
          </p>
        </div>
      </div>
    </section>;
};